import _ from 'lodash';
import React from 'react';import PropTypes from 'prop-types';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import { shippingOrders } from '../../../modules/customer/profile';
import * as customerSelectors from './../../../modules/customer/profile/selectors';
import { Panel, PanelGroup, Tabs, Tab } from 'react-bootstrap';
import { utcToDisplayDate } from './../../../common/formatting';
import Breadcrumbs from '././../../components/Breadcrumbs';
import ProcessSteps from '././../../components/ProcessSteps';
import HardwareList from './../products/hardwareProducts/addHardwareForm/components/HardwareList'
import SMSBox from './../../components/SMSBox'
import LoadingPanel from './../../components/LoadingPanel';
import classnames from 'classnames';
import moment from 'moment';
import { push } from 'connected-react-router';
import { BoxesRow, Box } from '../profilePage/components/';

const processStepsDefinition = [
    { name: "MayShip", displayName: "May Ship" },
    { name: "TransferToSlog", displayName: "Transfer To Slog" },
    { name: "Shipped", displayName: "Shipped" },
    { name: "Delivered", displayName: "Delivered" },
    { name: "Undelivered", displayName: "Undelivered" }
]

const smsBoxVisibleInStatus = [
    "Shipped",
    "Delivered",
    "Undelivered"
]

export const minDateForActiveOrders = moment().subtract(14, 'd');

const ShippingOrders = ({customerId, orders, activeTabOrder, activeOrderDevices, previousTabOrder, selectedTabName, setActiveOrder, setPreviousOrder, setActiveTab, isLoading, backToProfileView}) => {

    let isPreviousOrderView = selectedTabName === "Previous";
    let selectedOrder = isPreviousOrderView ? previousTabOrder : activeTabOrder;
    let currentStatus = selectedOrder !== undefined ? _.find(selectedOrder.statusChangeHistory, order => order.status === selectedOrder.currentStatus) : undefined;
    let activeOrders = shippingOrders.selectors.getActiveShippingOrdersList(orders);
    let previousOrders = shippingOrders.selectors.getPreviousShippingOrdersList(orders);
    let isTrackingVisible = selectedOrder.tracking !== undefined && selectedOrder.tracking.trackingNumber !== "";
    let smsBoxVisible = selectedOrder !== undefined && smsBoxVisibleInStatus.indexOf(selectedOrder.currentStatus) !== -1 && isTrackingVisible;

    let shippingOrderFormClass = classnames({
        'shippingOrders col-xs-12': true,
        'disabledOrder': false, //isPreviousOrderView,
    });
    return (
        <BoxesRow>
            <Box label="Fraktordre" className="shipping-orders">
                {isLoading &&
                    <LoadingPanel />
                }
                {!isLoading && selectedOrder !== undefined &&
                    <div>
                        <div className="col-md-3 col-xs-12 orders-column">
                            <Tabs defaultActiveKey={selectedTabName} id="order-tabs" onSelect={(tab) => setActiveTab(tab)}>
                                <Tab title={"Active (" + activeOrders.length + ")"} eventKey="Active">
                                    {activeOrders.length > 0 &&
                                        <PanelGroup activeKey={selectedOrder.id} accordion>
                                            {
                                                activeOrders.map((order, index) => {
                                                    let arrowButtonClass = classnames({
                                                        'glyphicon': true,
                                                        'glyphicon-triangle-bottom': order.id === selectedOrder.id,
                                                        'glyphicon-triangle-right': order.id !== selectedOrder.id
                                                    });
                                                    return (
                                                        <Panel
                                                            key={index}
                                                            header={<span>Shipping order: {order.id} <span className={arrowButtonClass}></span></span>}
                                                            eventKey={order.id}
                                                            collapsible={true}
                                                            onSelect={e => setActiveOrder(order.id)}>
                                                            <ProcessSteps
                                                                stepsDefinitions={processStepsDefinition}
                                                                stepsList={order.statusChangeHistory}
                                                                currentStepName={order.currentStatus}
                                                                />
                                                        </Panel>
                                                    )
                                                })
                                            }
                                        </PanelGroup>
                                    }
                                    {activeOrders.length === 0 &&
                                        <div className="no-orders-message alert alert-warning">
                                            No active orders, check "Previous" tab for historical orders
                                        </div>
                                    }
                                </Tab>
                                <Tab title={"Previous (" + previousOrders.length + ")"} eventKey="Previous" >
                                    {previousOrders.length > 0 &&
                                        <table className="previous-orders table table-striped table-hover">
                                            <thead>
                                                <tr>
                                                    <th>Dato:</th>
                                                    <th>ID:</th>
                                                    <th>Status:</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    previousOrders.map((order, index) => {
                                                        let rowClass = classnames({
                                                            'selected': order.id === selectedOrder.id,
                                                        });
                                                        return (
                                                            <tr key={index} className={rowClass} onClick={e => setPreviousOrder(order.id)}>
                                                                <td>
                                                                    {utcToDisplayDate(order.createDateTime)}
                                                                </td>
                                                                <td className="order-id-column">
                                                                    {order.id}
                                                                </td>
                                                                <td>
                                                                    {order.currentStatus.split(/(?=[A-Z])/).join(" ")}
                                                                </td>
                                                            </tr>
                                                        )
                                                    })
                                                }
                                            </tbody>
                                        </table>
                                    }
                                    {previousOrders.length === 0 &&
                                        <div className="no-orders-message alert alert-warning">
                                            No historical orders
                                        </div>
                                    }
                                </Tab>
                            </Tabs>
                        </div>
                        <div className="col-md-4 col-xs-12 details-column first-column">
                            <div className="row">
                                <div className="col-xs-12">
                                    <div className="details-row">
                                        <h4>Order:</h4>
                                        {selectedOrder.id !== 0 &&
                                            <div className="order">{selectedOrder.id}</div>
                                        }
                                    </div>
                                    {selectedOrder.shippingMethod !== undefined &&
                                        <div className="details-row">
                                            <h4>Service Type:</h4>
                                            <div className="service-type">
                                                {selectedOrder.shippingMethod.split(/(?=[A-Z])/).join(" ")}
                                            </div>
                                        </div>
                                    }
                                    {selectedOrder !== undefined && selectedOrder.orderedDevices &&
                                        <div className="details-row">
                                            <h4>Ordered Devices: </h4>
                                            <div className="row details-row">
                                                <div className="hardwareProduct col-xs-12 col-sm-12 col-md-12">
                                                    <HardwareList hardwareList={selectedOrder.orderedDevices} />
                                                </div>
                                            </div>
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                        <div className="col-md-3 col-xs-12 details-column">
                            <div className="row">
                                <div className="col-xs-12 details-row">
                                    <h4>Adresse:</h4>
                                    {
                                        selectedOrder.shipToAddress !== undefined &&
                                        <div className="address">
                                            <div>{selectedOrder.shipToAddress.street} {selectedOrder.shipToAddress.streetLetter}{selectedOrder.shipToAddress.streetNo},</div>
                                            <div>{selectedOrder.shipToAddress.zip} {selectedOrder.shipToAddress.city}</div>
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                        <div className="col-md-3 col-xs-12 details-column">
                            <div className="row">
                                <div className="col-xs-12">
                                    <div className="details-row">
                                        <h4>Shipping Order Status:</h4>
                                        {currentStatus !== undefined &&
                                            <div className="process-steps full-width">
                                                <div className="process-step">
                                                    <button disabled type="button" className="btn btn-primary btn-circle step circle-medium active-step order-status"></button>
                                                    <div className="order-status details active-step">
                                                        <div className="step-name">{currentStatus.status}</div>
                                                        <div className="date">{utcToDisplayDate(currentStatus.eventDateTime)}</div>
                                                    </div>
                                                </div>
                                            </div>
                                        }
                                    </div>
                                    {isTrackingVisible &&
                                        <div className="details-row">
                                            <h4>Postal Tracking Number:</h4>
                                            <div className="postal-tracking">
                                                <a href={selectedOrder.tracking.trackingLink} target="_blank">
                                                    {selectedOrder.tracking.trackingNumber}
                                                </a>
                                            </div>
                                        </div>
                                    }
                                    {!isPreviousOrderView && isTrackingVisible &&
                                        <div className="details-row">
                                            <h4>Send the track to customer:</h4>
                                            <SMSBox defaultSmsContent={"Tracking number: " + selectedOrder.tracking.trackingNumber} />
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                }
        </Box>
        </BoxesRow>
    )
};

const mapStateToProps = createStructuredSelector({
    customerId: customerSelectors.getCustomerID,
    orders: shippingOrders.selectors.getShippingOrders,
    activeTabOrder: shippingOrders.selectors.getActiveShippingOrder,
    previousTabOrder: shippingOrders.selectors.getPreviousShippingOrder,
    selectedTabName: shippingOrders.selectors.getSelectedTabName,
    isLoading: shippingOrders.selectors.isLoading
});

const mapDispatchToProps = (dispatch, props) => ({
    setActiveOrder: (orderId) => dispatch(shippingOrders.actions.setActiveOrder(orderId)),
    setPreviousOrder: (orderId) => dispatch(shippingOrders.actions.setPreviousOrder(orderId)),
    setActiveTab: (selectedTabName) => dispatch(shippingOrders.actions.setActiveTab(selectedTabName)),
    backToProfileView: (customerId) => dispatch(push(`/customer/${customerId}`))
});

export default connect(mapStateToProps, mapDispatchToProps)(ShippingOrders)